var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.71,
    x2: 226.224,
    xlinkHref: "#lg1",
    y1: 92.718,
    y2: 226.232
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.368,
    x2: 144.368,
    y1: 211.001,
    y2: 289.225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.71,
    x2: 226.224,
    xlinkHref: "#lg2",
    y1: 315.761,
    y2: 449.276
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.647,
    x2: 423.089,
    y1: 273.639,
    y2: 423.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.999,
    x2: 277.77,
    xlinkHref: "#lg3",
    y1: 427.993,
    y2: 347.764
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.52,
    x2: 248.049,
    xlinkHref: "#lg4",
    y1: 375.472,
    y2: 248.001
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.58,
    x2: 301.802,
    y1: 216.58,
    y2: 301.802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.368,
    x2: 144.368,
    xlinkHref: "#lg3",
    y1: 435.983,
    y2: 497.478
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.632,
    x2: 365.632,
    xlinkHref: "#lg4",
    y1: 458.481,
    y2: 535.209
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -2289.349 453.906)",
    gradientUnits: "userSpaceOnUse",
    x1: 1661.829,
    x2: 1643.069,
    y1: -2186.68,
    y2: -2186.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.787,
    x2: 306.027,
    xlinkHref: "#lg2",
    y1: 59.277,
    y2: 59.277
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(0 1 -1 0 -2883.958 -427.608)",
    gradientUnits: "userSpaceOnUse",
    x1: 619.522,
    x2: 600.762,
    xlinkHref: "#lg1",
    y1: -3334.682,
    y2: -3334.682
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m235.338 144.227c-16.361 17.416-16.361 44.968 0 62.383 10.676 11.369 25.693 16.007 39.92 13.913 6.175-.91 11.683 3.977 11.683 10.217v33.349c0 12.625-10.233 22.858-22.858 22.858h-33.349c-6.24 0-11.127-5.507-10.217-11.683 2.093-14.227-2.544-29.243-13.913-39.92-17.415-16.361-44.968-16.361-62.383 0-11.369 10.676-16.006 25.692-13.913 39.92.91 6.175-3.977 11.683-10.217 11.683h-33.352c-12.625 0-22.858-10.233-22.858-22.858v-33.349c0-6.24-5.515-11.127-11.691-10.217-14.219 2.093-29.243-2.544-39.919-13.913-16.361-17.416-16.361-44.968 0-62.383 10.676-11.369 25.701-16.007 39.919-13.913 6.176.91 11.691-3.977 11.691-10.217v-33.35c0-12.625 10.233-22.858 22.858-22.858h33.349c6.24 0 11.127-5.515 10.217-11.691-2.093-14.219 2.544-29.243 13.913-39.92 17.415-16.361 44.968-16.361 62.383 0 11.369 10.677 16.006 25.701 13.913 39.92-.91 6.175 3.977 11.691 10.217 11.691h33.349c12.625 0 22.858 10.233 22.858 22.858v33.349c0 6.24-5.507 11.127-11.683 10.217-14.224-2.092-29.241 2.545-39.917 13.914z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.27 206.61c10.676 11.369 25.7 16.006 39.92 13.913 6.176-.91 11.691 3.977 11.691 10.217v33.349c0 12.625 10.233 22.858 22.858 22.858h33.349c6.24 0 11.127-5.507 10.217-11.683-2.093-14.227 2.544-29.243 13.913-39.92 17.415-16.361 44.968-16.361 62.383 0 11.369 10.676 16.006 25.692 13.913 39.92-.91 6.175 3.977 11.683 10.217 11.683h33.349c12.625 0 22.858-10.233 22.858-22.858v-33.349c0-6.24-5.507-11.127-11.683-10.217-14.227 2.093-29.243-2.544-39.92-13.913-5.055-5.381-8.543-11.73-10.474-18.448h-223.065c1.932 6.718 5.42 13.068 10.474 18.448z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.338 367.271c-16.361 17.416-16.361 44.968 0 62.383 10.676 11.369 25.693 16.007 39.92 13.913 6.175-.91 11.683 3.977 11.683 10.217v33.349c0 12.625-10.233 22.858-22.858 22.858h-33.349c-6.24 0-11.127-5.507-10.217-11.683 2.093-14.227-2.544-29.243-13.913-39.92-17.415-16.361-44.968-16.361-62.383 0-11.369 10.676-16.006 25.692-13.913 39.92.91 6.175-3.977 11.683-10.217 11.683h-33.352c-12.625 0-22.858-10.233-22.858-22.858v-33.349c0-6.24-5.515-11.127-11.691-10.217-14.219 2.093-29.243-2.544-39.919-13.913-16.361-17.416-16.361-44.968 0-62.383 10.676-11.369 25.701-16.007 39.919-13.913 6.176.91 11.691-3.977 11.691-10.217v-33.349c0-12.625 10.233-22.858 22.858-22.858h33.349c6.24 0 11.127-5.515 10.217-11.691-2.093-14.219 2.544-29.243 13.913-39.92 17.415-16.361 44.968-16.361 62.383 0 11.369 10.677 16.006 25.701 13.913 39.92-.91 6.175 3.977 11.691 10.217 11.691h33.349c12.625 0 22.858 10.233 22.858 22.858v33.349c0 6.24-5.507 11.127-11.683 10.217-14.224-2.094-29.241 2.544-39.917 13.913z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.398 367.271c-16.361 17.416-16.361 44.968 0 62.383 10.676 11.369 25.693 16.007 39.92 13.913 6.175-.91 11.683 3.977 11.683 10.217v33.349c0 12.625-10.233 22.858-22.858 22.858h-33.349c-6.24 0-11.127-5.507-10.217-11.683 2.093-14.227-2.544-29.243-13.913-39.92-17.415-16.361-44.968-16.361-62.383 0-11.369 10.676-16.006 25.692-13.913 39.92.91 6.175-3.977 11.683-10.217 11.683h-33.349c-12.625 0-22.858-10.233-22.858-22.858v-33.349c0-6.24-5.515-11.127-11.691-10.217-14.219 2.093-29.243-2.544-39.919-13.913-16.361-17.416-16.361-44.968 0-62.383 10.676-11.369 25.701-16.007 39.919-13.913 6.176.91 11.691-3.977 11.691-10.217v-33.349c0-12.625 10.233-22.858 22.858-22.858h33.349c6.24 0 11.127-5.515 10.217-11.691-2.093-14.219 2.544-29.243 13.913-39.92 17.415-16.361 44.968-16.361 62.383 0 11.369 10.677 16.006 25.701 13.913 39.92-.91 6.175 3.977 11.691 10.217 11.691h33.349c12.625 0 22.858 10.233 22.858 22.858v33.349c0 6.24-5.507 11.127-11.683 10.217-14.228-2.094-29.244 2.544-39.92 13.913z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m275.258 353.357c6.175.91 11.683-3.977 11.683-10.217v-33.349c0-12.625-10.233-22.858-22.858-22.858h-33.349c-6.24 0-11.127-5.515-10.217-11.691 2.093-14.219-2.544-29.243-13.913-39.92-8.654-8.129-19.81-12.215-30.983-12.266-3.612 9.771-5.579 20.559-5.579 32.114 0 26.657 7.216 50.581 25.69 66.996l42.398 42.399c10.413-9.377 24.096-13.125 37.128-11.208z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.792 509.992h33.349c12.625 0 22.858-10.234 22.858-22.858v-33.349c0-6.24-5.507-11.127-11.683-10.217-14.227 2.093-29.243-2.544-39.92-13.913-16.361-17.415-16.361-44.968 0-62.383 6.289-6.697 14.088-11.039 22.34-13.065l-116.129-116.132c-9.402 10.42-13.161 24.127-11.241 37.167.91 6.175-3.977 11.691-10.217 11.691h-33.349c-12.625 0-22.858 10.233-22.858 22.858v33.349c0 6.24-5.515 11.127-11.691 10.217-13.022-1.917-26.71 1.829-37.124 11.204l116.103 116.104c2.032-8.229 6.369-16.003 13.049-22.276 17.415-16.361 44.968-16.361 62.383 0 11.369 10.676 16.007 25.693 13.913 39.92-.91 6.176 3.977 11.683 10.217 11.683z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_7_)",
    r: 89.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.38 297.572c-7.775 0-15.085-3.028-20.582-8.525l-24.752-24.752c-5.176-5.175-5.176-13.567 0-18.743 5.175-5.176 13.567-5.176 18.743 0l24.752 24.752c.63.63 1.348.762 1.839.762s1.209-.132 1.839-.762l53.994-53.993c5.176-5.176 13.567-5.176 18.743 0 5.175 5.175 5.175 13.567 0 18.743l-53.993 53.993c-5.499 5.497-12.808 8.525-20.583 8.525z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m12.27 429.654c10.676 11.369 25.7 16.006 39.92 13.913 6.176-.91 11.691 3.977 11.691 10.217v33.349c0 12.625 10.233 22.858 22.858 22.858h33.349c6.24 0 11.127-5.507 10.217-11.683-2.093-14.227 2.544-29.243 13.913-39.92 17.415-16.361 44.968-16.361 62.383 0 11.369 10.676 16.006 25.692 13.913 39.92-.91 6.175 3.977 11.683 10.217 11.683h33.349c12.625 0 22.858-10.233 22.858-22.858v-33.349c0-6.24-5.507-11.127-11.683-10.217-14.227 2.093-29.243-2.544-39.92-13.913-5.055-5.381-8.543-11.73-10.474-18.448h-223.065c1.932 6.718 5.42 13.067 10.474 18.448z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.534 429.654c10.676 11.369 25.7 16.006 39.92 13.913 6.176-.91 11.691 3.977 11.691 10.217v33.349c0 12.625 10.233 22.858 22.858 22.858h33.349c6.24 0 11.127-5.507 10.217-11.683-2.093-14.227 2.544-29.243 13.913-39.92 17.415-16.361 44.968-16.361 62.383 0 11.369 10.676 16.006 25.692 13.913 39.92-.91 6.175 3.977 11.683 10.217 11.683h33.349c12.625 0 22.858-10.233 22.858-22.858v-33.349c0-6.24-5.507-11.127-11.683-10.217-14.227 2.093-29.243-2.544-39.92-13.913-5.055-5.381-8.543-11.73-10.474-18.448h-223.065c1.931 6.718 5.419 13.067 10.474 18.448z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m397.829 112.171c-7.446-7.446-7.446-19.519 0-26.966l36.553-36.553c7.446-7.446 19.519-7.446 26.966 0 7.446 7.446 7.446 19.519 0 26.966l-36.553 36.553c-7.447 7.446-19.52 7.446-26.966 0z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.436 104.191c-10.531 0-19.068-8.537-19.068-19.068v-51.694c0-10.531 8.537-19.068 19.068-19.068 10.531 0 19.068 8.537 19.068 19.068v51.693c0 10.532-8.537 19.069-19.068 19.069z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.809 188.564c0-10.531 8.537-19.068 19.068-19.068h51.693c10.531 0 19.068 8.537 19.068 19.068 0 10.531-8.537 19.068-19.068 19.068h-51.693c-10.531 0-19.068-8.537-19.068-19.068z",
    fill: "url(#SVGID_12_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.04ce0af9749d3ad78910223b2e5b35a6.svg";
export { ForwardRef as ReactComponent };